import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef} from '../../../lib/react/higher-order-components';
import OENotification from '../../../lib/notification/oe-notification';
import {OEViewType} from '../../../lib/oe-types';
import OEStartSelectionViewStd from './oe-start-selection-view-std';
import {OEDefaultConfigFactory} from '../../oe-default-configs';

export function OEStartSelectionViewFactory(props) {
    const {fref, startViewConfig, ...rest} = props;

    const openFn = (sender, isOpen) => {
        if(!props.appComponent || !props.appComponent.uiLayer) return;
        props.appComponent.uiLayer.notificationCenter.post(OENotification.viewOpenStateChanged, {
            type: OEViewType.startSelection,
            isOpen: isOpen,
            sender: sender
        });
    };

    return <OEStartSelectionViewStd logo={startViewConfig ? startViewConfig.logo : null} {...rest} ref={fref} onOpenStateChanged={openFn}/>;
}

OEStartSelectionViewFactory.defaultProps = {
    moduleId: '',
    config: OEDefaultConfigFactory.startSelection()
};

OEStartSelectionViewFactory.propTypes = {
    moduleId: PropTypes.string,
    config: OEDefaultConfigFactory.startSelectionDecl,
    startViewConfig: OEDefaultConfigFactory.startViewDecl
};

export const OEStartSelectionViewFactoryConnected = connectAppEnv((env) => { return {
    version: env.config.version,
    target: env.config.target,
    appComponent: env.component,
    config: env.config.module.uiLayerConfig.startSelection,
    startViewConfig: env.config.module.uiLayerConfig.startView
}})(OEStartSelectionViewFactory);

export default frefFromRef(OEStartSelectionViewFactoryConnected);